// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".store-badge-google-play img{width:auto;height:70px}.store-badge-app-store img{width:auto;height:48px}", ""]);
// Exports
module.exports = exports;
